import CommentData from '../../../types/commentData';
import { useUserProfile } from '../../../utils/hooks';
import UserRoundedImage from '../../atoms/rounded-image/UserRoundedImage';

interface QuestionProps {
  comment: CommentData;
}

export default function Question({ comment }: QuestionProps) {
  const userProfile = useUserProfile(comment.userId);

  return (
    <div className="flex gap-4 items-center">
      {userProfile && <UserRoundedImage userProfile={userProfile} />}
      <div>
        {userProfile !== undefined && (
          <p className="text-author -mb-1">
            {userProfile ? userProfile.firstName + ' ' + userProfile.lastName : 'Anonymous'}
          </p>
        )}
        <p>{comment.body}</p>
      </div>
    </div>
  );
}
